export default __webpack_public_path__ + "static/media/lk_4.c2184618.jpg";